import { gql } from '@apollo/client';

import { contentfulSysIdFragment } from '../../utils/contentful/contentfulQuery';

const messageFragment = gql`
  fragment MessageAll on Message {
    ...ContentfulSysId
    key
    value
  }
  ${contentfulSysIdFragment}
`;

export const intlProviderQuery = gql`
  query IntlMessages($preview: Boolean!, $locale: String!) {
    messageCollection(preview: $preview, locale: $locale) {
      items {
        ...MessageAll
      }
    }
  }
  ${messageFragment}
`;

/** Local messages query with a different operation name to avoid cache key conflicts. */
export const localIntlProviderQuery = gql`
  query LocalIntlMessages($preview: Boolean!, $locale: String!) {
    messageCollection(preview: $preview, locale: $locale, limit: 100) {
      items {
        ...MessageAll
      }
    }
  }
  ${messageFragment}
`;
